import { css } from 'react-emotion';

const styles = {
	selectedCardVM: css`
		.vm .web-ui-components & {
			background-color: #7a3371;
			border-color: #7a3371;
			color: #ffffff;
			.c-m-payee-card__segment-alpha {
				color: #ffffff;
			}
		}
	`,
	cardVM: css`
		.vm .web-ui-components & {
			.c-m-payee-card__footer {
				flex-wrap: wrap;
			}
			.c-m-payee-card__segment-zeta {
				text-align: left;
			}
		}
	`,
};

export default styles;
